// src/components/CheckboxDropdown.tsx

import React, { useState, useRef, useEffect } from 'react';
import '../css/checkboxdropdown.css'; // Asegúrate de crear este archivo para los estilos

interface CheckboxDropdownProps {
  options: string[];
  selectedOptions: string[];
  onChange: (selected: string[]) => void;
  placeholder?: string;
}

const CheckboxDropdown: React.FC<CheckboxDropdownProps> = ({
  options,
  selectedOptions,
  onChange,
  placeholder = 'Seleccione estado(s)',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionChange = (option: string) => {
    if (selectedOptions.includes(option)) {
      onChange(selectedOptions.filter((item) => item !== option));
    } else {
      onChange([...selectedOptions, option]);
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const displayText =
    selectedOptions.length > 0
      ? selectedOptions.join(', ')
      : placeholder;

  return (
    <div className="checkbox-dropdown" ref={dropdownRef}>
      <button
        type="button"
        className="dropdown-toggle"
        onClick={toggleDropdown}
      >
        {displayText} <span className="arrow">{isOpen ? '▲' : '▼'}</span>
      </button>
      {isOpen && (
        <div className="dropdown-menu">
          {options.map((option) => (
            <label key={option} className="dropdown-item">
              <input
                type="checkbox"
                checked={selectedOptions.includes(option)}
                onChange={() => handleOptionChange(option)}
              />{' '}
              {option}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default CheckboxDropdown;
